export default __webpack_public_path__ + "static/media/CL03.fe197f0d.mp3";